import React, { useState } from "react";
import { Button, Box, Typography, Snackbar, Alert, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, styled, tableCellClasses, IconButton } from "@mui/material";
import { useWebSocket } from "../../../../../services/websocket/WebSocketProvider";
import SupportChatService from "../../../../../services/api/supportchat";
import OverlayLoader from '../../../../../components/overlayLoader';
import { useNavigate } from 'react-router-dom';
import { OpenInNew } from "@mui/icons-material";
import { optimo_whatsapp_number } from "../../../../../config";
import { useAuth } from "../../../../../services/auth/AuthContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const SupportChat = ({ userId, optimo_phone_id, enquiryId, active_chats, addNewChatRecord }) => {
    // const [message, setMessage] = useState("");
    // const maxCharacters = 500;
    const [open, setOpen] = useState(false);
    // useWebSocket({
    //     onMessage: (message) => {
    //         console.log(message);
    //     }
    // });
    const navigate = useNavigate();
    const { setIsAuthenticated } = useAuth();

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [snackSeverity, setSnackSeverity] = useState('');

    const activeChat = active_chats?.find(chat => chat.status === 'active');
    const nonActiveChats = active_chats?.filter(chat => chat.status !== 'active');

    const handleClose = () => {
        setShowSnackbar(false);
        setSnackBarMessage('');
        setSnackSeverity('');
    };

    // const sendMessage = (msg) => {
    //     setOpen(true);
    //     SupportChatService.sendMessage(
    //         {
    //             userId: userId,
    //             enquiryId: enquiryId,
    //             message: msg,
    //         }
    //     ).then(
    //         (response) => {
    //             if (response.success) {
    //                 setMessage("");
    //             }
    //             setOpen(false);
    //             setShowSnackbar(true);
    //             setSnackBarMessage('Message sent successfully');
    //             setSnackSeverity('success');
    //         }
    //     ).catch(
    //         (exception) => {
    //             setOpen(false);
    //             console.log(exception);
    //         }
    //     );
    // };


    const sendTemplateMessage = () => {
        setOpen(true);
        console.log(parseInt(optimo_whatsapp_number)!==parseInt(optimo_phone_id))
        SupportChatService.sendTemplate(
            {
                enquiryId: enquiryId
            },
            setIsAuthenticated,
            navigate,
            parseInt(optimo_whatsapp_number)!==parseInt(optimo_phone_id)
        ).then((response) => {
            if (response.success) {
                // setMessage("");
                addNewChatRecord(response.chat);
            }
            setOpen(false);
            setShowSnackbar(true);
            setSnackBarMessage('Template message sent successfully');
            setSnackSeverity('success');
        }).catch((exception) => {
            setOpen(false);
            setShowSnackbar(true);
            setSnackBarMessage('Failed to send template message');
            setSnackSeverity('error');
            console.log(exception);
        });
    };

    const goToChat = () => {
        navigate('/support?chatId=' + activeChat.id);
    };

    return (
        <>
            <OverlayLoader
                open={open}
                text="Initializing support chat"
            />
            <Snackbar open={showSnackbar} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={snackSeverity} sx={{ width: '100%' }}>
                    <Typography>{snackBarMessage}</Typography>
                </Alert>
            </Snackbar>
            {activeChat ? (
                <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        Active Support Chat
                    </Typography>
                    {/* Add your active chat UI components here */}
                    <Box display="flex" flexDirection={'column'} gap={2}>
                        <Button variant="contained" color="primary" onClick={goToChat} fullWidth>
                            Go to chat
                        </Button>
                    </Box>
                </Box>
            ) : (
                <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        Initialize Support Chat
                    </Typography>
                    <Box display="flex" flexDirection={'column'} gap={2}>
                        {/* <Box flex={1}>
                            <TextField
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Type a message..."
                                fullWidth
                                variant="standard"
                                margin="normal"
                                multiline
                                minRows={4}
                                maxRows={10}
                                helperText={`${message.length}/${maxCharacters}`}
                            />
                            <Button variant="contained" color="primary" onClick={() => sendMessage(message)} fullWidth>
                                Send
                            </Button>
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="center" sx={{ my: 2 }}>
                            <SwapHorizIcon />
                            <Typography variant="body1" sx={{ mx: 1 }}>
                                OR
                            </Typography>
                        </Box> */}
                        <Box flex={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            <Button variant="contained" color="secondary" onClick={sendTemplateMessage} fullWidth>
                                Send Template
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
            <Box sx={{ mt:2, p: 2, border: '1px solid #ccc', borderRadius: '8px', mb: 2 }}>
                <Typography variant="h6" component="h2" gutterBottom>
                    Chat History
                </Typography>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center">Chat ID</StyledTableCell>
                                <StyledTableCell align="center">Status</StyledTableCell>
                                <StyledTableCell align="center">View Chat</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {nonActiveChats?.length > 0 ? nonActiveChats.map((chat) => (
                                <StyledTableRow
                                    key={chat.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <StyledTableCell align="center">{chat.id}</StyledTableCell>
                                    <StyledTableCell align="center">{chat.status}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        <IconButton
                                            onClick={() => navigate('/support?chatId=' + chat.id)}
                                        >
                                            <OpenInNew />
                                        </IconButton>
                                    </StyledTableCell>
                                </StyledTableRow>
                            )) : (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={3} align="center">No chat history found</StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    );
};

export default SupportChat;